import React from 'react';
import PropTypes from 'prop-types';
import BookmakerLink from '../../bookmakerLink';

const CardNumberError = ({
    topUpUrl,
    topUpBookmakerName,
    topUpPhoneNumber,
    isPhone,
}) => {
    const urlLink = (topUpBookmakerName !== '' && topUpBookmakerName !== null) ? (
        <BookmakerLink
            titleText="To add a new card visit"
            bookmakerUrl={topUpUrl}
            bookmakerName={topUpBookmakerName}
        />
    ) : null;

    const phoneLink = (topUpPhoneNumber !== '' && topUpPhoneNumber !== null) ? (
        <BookmakerLink
            titleText="Or call"
            phoneNumber={topUpPhoneNumber}
            isPhone={isPhone}
        />
    ) : null;

    return (
        <div>
            <div className="bs-cardNumberError__text">
                    No card details can be found for this account
            </div>
            {urlLink}
            {phoneLink}
        </div>
    );
}

CardNumberError.defaultProps = {
    topUpUrl: '',
    topUpBookmakerName: '',
    topUpPhoneNumber: '',
    isPhone: false,
};

CardNumberError.propTypes = {
    topUpUrl: PropTypes.string,
    topUpBookmakerName: PropTypes.string,
    topUpPhoneNumber: PropTypes.string,
    isPhone: PropTypes.bool,
};

export default CardNumberError;



// WEBPACK FOOTER //
// /src/js/common/topUp/components/CardNumberError.jsx